import { apiClient } from './client';

export async function previewSubscriptionChange(subscriptionId, payload) {
  const { data } = await apiClient.post(`/api/system/subscriptions/${subscriptionId}/change-preview`, payload);
  return data.data ?? data;
}

export async function createSubscriptionChange(subscriptionId, payload) {
  const { data } = await apiClient.post(`/api/system/subscriptions/${subscriptionId}/change-requests`, payload);
  return data.data ?? data;
}

export async function getSubscriptionChangeRequests(params = {}) {
  const { data } = await apiClient.get('/api/system/subscription-change-requests', { params });
  return data;
}

export async function getSubscriptionChangeRequestsForSubscription(subscriptionId) {
  const { data } = await apiClient.get(`/api/system/subscriptions/${subscriptionId}/change-requests`);
  return data.data ?? data;
}

export async function getSubscriptionChangeRequest(id) {
  const { data } = await apiClient.get(`/api/system/subscription-change-requests/${id}`);
  return data.data ?? data;
}

export async function cancelSubscriptionChange(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/subscription-change-requests/${id}/cancel`, payload);
  return data.data ?? data;
}

export async function applySubscriptionChange(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/subscription-change-requests/${id}/apply`, payload);
  return data.data ?? data;
}

export async function applyDueSubscriptionChanges() {
  const { data } = await apiClient.post('/api/system/subscription-change-requests/apply-due');
  return data;
}

export async function getTenantModuleAccessEvents(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/module-access-events`);
  return data.data ?? data;
}

export async function getCustomerModuleAccessEvents(customerId) {
  const { data } = await apiClient.get(`/api/system/customers/${customerId}/module-access-events`);
  return data.data ?? data;
}

export async function previewPortalSubscriptionChange(customerId, subscriptionId, payload) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/subscriptions/${subscriptionId}/change-preview`,
    payload,
  );
  return data.data ?? data;
}

export async function createPortalSubscriptionChange(customerId, subscriptionId, payload) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/subscriptions/${subscriptionId}/change-requests`,
    payload,
  );
  return data.data ?? data;
}

export async function getPortalSubscriptionChangeRequests(customerId, subscriptionId) {
  const { data } = await apiClient.get(
    `/api/customer-portal/customers/${customerId}/subscriptions/${subscriptionId}/change-requests`,
  );
  return data.data ?? data;
}

export async function getPortalTrialConversion(customerId, subscriptionId) {
  const { data } = await apiClient.get(
    `/api/customer-portal/customers/${customerId}/subscriptions/${subscriptionId}/trial-conversion`,
  );
  return data.data ?? data;
}

export async function storePortalTrialConversionConsent(customerId, subscriptionId, payload) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/subscriptions/${subscriptionId}/trial-conversion-consent`,
    payload,
  );
  return data.data ?? data;
}

export async function revokePortalTrialConversionConsent(customerId, subscriptionId) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/subscriptions/${subscriptionId}/trial-conversion-consent/revoke`,
  );
  return data.data ?? data;
}

export async function cancelPortalSubscriptionRenewal(customerId, subscriptionId, payload = {}) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/subscriptions/${subscriptionId}/cancel-renewal`,
    payload,
  );
  return data;
}

export async function cancelPortalSubscriptionChange(customerId, changeRequestId, payload = {}) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/subscription-change-requests/${changeRequestId}/cancel`,
    payload,
  );
  return data.data ?? data;
}
